module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chap",
    attrs: {
      "epub:type": "chapter",
      "id": "chap-004"
    }
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _c('h2', {
    staticClass: "chap_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("2:8-14 RAHAB’S FAITH")])]), _c('div', {
    staticClass: "chapeau"
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_c('sup', [_vm._v("8")]), _vm._v("Before the men"), _c('a', {
    staticClass: "apnb",
    attrs: {
      "epub:type": "noteref",
      "href": "#/p1chap5#ntb-003",
      "id": "ap_ntb-003-1"
    }
  }, [_vm._v("a")]), _vm._v(" lay down, she came up to them on the roof "), _c('sup', [_vm._v("9")]), _vm._v("and said to the men, “I know that the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" has given you the land, and that the fear of you has fallen upon us, and that all the inhabitants of the land melt away before you. "), _c('sup', [_vm._v("10")]), _vm._v("For we have heard how the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" dried up the water of the Red Sea before you when you came out of Egypt, and what you did to the two kings of the Amorites who were beyond the Jordan, to Sihon and Og, whom you devoted to destruction."), _c('a', {
    staticClass: "apnb",
    attrs: {
      "epub:type": "noteref",
      "href": "#/p1chap5#ntb-004",
      "id": "ap_ntb-004-1"
    }
  }, [_vm._v("b")]), _vm._v(" "), _c('sup', [_vm._v("11")]), _vm._v("And as soon as we heard it, our hearts melted, and there was no spirit left in any man because of you, for the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" your God, he is God in the heavens above and on the earth beneath. "), _c('sup', [_vm._v("12")]), _vm._v("Now then, please swear to me by the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" that, as I have dealt kindly with you, you also will deal kindly with my father’s house, and give me a sure sign "), _c('sup', [_vm._v("13")]), _vm._v("that you will save alive my father and mother, my brothers and sisters, and all who belong to them, and deliver our lives from death.” "), _c('sup', [_vm._v("14")]), _vm._v("And the men said to her, “Our life for yours even to death! If you do not tell this business of ours, then when the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" gives us the land we will deal kindly and faithfully with you.”")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VERVIEW:")])]), _vm._v(" The reformers note how a holy God instills fear: terror in the ungodly, repentant yet trusting fear in those whom he calls. Our commentators marvel that Rahab already knew of Israel’s salvation history and of Israel’s redeemer God. Her confession of belief while in an ungodly community is seen as conclusive evidence of her true, even if still unformed, faith. Indeed, the reformers find that this faith of a Gentile woman—faith of a (former) prostitute—puts to shame that of many in Israel, or even the church. She has a faith that leads to action, as she devises a means of escape for the spies, and secures a promise of salvation for her family from the coming destruction of Jericho.")]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-026"
    }
  }, [_c('h3', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('b', [_vm._v("2:8-11 "), _c('i', [_vm._v("Fear of the Lord Is the Beginning of Faith")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TRENGTHENS THE")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EAK AND")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERRIFIES THE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROUD")]), _vm._v(".")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UDWIG")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AVATER:")]), _vm._v(" From these words we learn that God instills terror in those whom he intends to punish. For up to this point the Canaanites, together with the other nations, had been very frightening to the Israelites. For when Moses had sent out spies to learn what sorts of persons they were, the Israelites were very afraid and began to look back toward Egypt. But now the Canaanites in their turn were quite thunderstruck and filled with dread. This is what Rahab makes clear in her many words. For the Lord had said in Deuteronomy 2, “On this very day I shall begin to send the fear and dread of you over the peoples who live here and there under heaven, that they who hear of your reputation may come to tremble and grow weak in your presence.” Later, in Deuteronomy 11 he says, “No one shall dare to stand before you, because the Lord your God shall cause fear and dread of you to cover the face of the earth that you are about to trample under foot, just as he told you.” Exodus 13 contains the same account. Histories often recount how unwarlike and little-known nations have acquired such great power that they become a source of horror to the most savage and warlike nations. Even private individuals, who once were bold, soon fall prey to such weakness of mind that they look for places to hide; and a leaf falling from a tree, just like God threatening in his law those who rebel, throws them into fits of terror. God, moreover, typically crushes in this way the proud crest of arrogant men. Pagan writers say that human minds have been thunderstruck by the god Pan. But the "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_36",
      "title": "36"
    }
  }, [_vm._v("Scriptures teach that God raises up the timid, and instills dread of himself in those haughty of heart. Sometimes he throws them into inner turmoil; sometimes he sends upon them an external dread. And so let us fear God, who can grant strength and take it away from whomever he pleases. Let us attribute nothing to ourselves nor despise others. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILY 9 ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 2:8-11")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-182",
      "id": "ap_ntf-182-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AHAB")]), _vm._v(" K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NEW OF")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD’S")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROMISES TO")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SRAEL")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ECAUSE")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EVEALED")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEM TO")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ER")]), _vm._v(".")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IOVANNI")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IODATI:")]), _vm._v(" Rahab might possibly have heard talk of God’s promises made to his people to give them the country, but that she so firmly persuaded herself that it will come to pass proceeded from an internal work of God. A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNOTATIONS ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 2:9")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-183",
      "id": "ap_ntf-183-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERTAINTY OF")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AHAB’S")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AITH")]), _vm._v(".")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANCELOT")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IDLEY:")]), _vm._v(" Note the certainty and sureness of the faith of this woman Rahab, who knew surely that God would deliver the land to the Israelites; for that reason she spoke in the past tense rather than the future tense, saying, “I know that the Lord has given this land to you.” A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNOTATIONS ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 2:8")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-184",
      "id": "ap_ntf-184-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AHAB’S")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RESENCE OF")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IND IN A")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RISIS")]), _vm._v(".")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALVIN:")]), _vm._v(" It appears, however, that Rahab was not at all dismayed, since she bargains with so much presence of mind, and so calmly, for her own safety and that of her family. And in this the calmness and firmness her faith, which is elsewhere commended, is evident. For on human principles she never would have braved the fury of the king and people, and become a humble petitioner to guests half dead with terror. Many, indeed, think there is something ridiculous in the praise bestowed upon her both by James and the author of the epistle to the Hebrews . . . when they place her in the catalog of the faithful. But anyone who will carefully weigh all the circumstances will easily perceive that she was endowed with a lively faith. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 2:7 [9]")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-185",
      "id": "ap_ntf-185-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AHAB")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISPLAYED A")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ODLY")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EAR")]), _vm._v(", U"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NLIKE THE")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EAR")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("THERS IN")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERICHO")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AD")]), _vm._v(".")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALVIN:")]), _vm._v(" While the courage of all others had thus melted away, still they prepared to resist with the stubbornness of despair; in this we see that when the wicked are broken and crushed by the hand of God, they are not so subdued as to receive the yoke, but in their terror and anxiety become incapable of being tamed. Here, too, we have to observe how in a common fear, believers differ from unbelievers, and how the faith of Rahab displays itself. She herself was afraid like any other of the people; but when she reflects that she has to do with God, she concludes that her only remedy is to shun evil by yielding humbly and calmly, as resistance would be altogether futile. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 2:7 [9]")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-186",
      "id": "ap_ntf-186-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AHAB’S")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EMARKABLE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONFESSION OF")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AITH")]), _vm._v(".")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UDWIG")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AVATER:")]), _vm._v(" Rahab did not conceal her faith but professed it publicly. Thus let us learn also to profess our own faith. But what kind of confession is this? She confesses that the God of Israel is the only God who rules things in heaven and things on earth, and that he is the one who will save the Israelites (that is, the righteous), and destroy the wicked. . . . Although there is no explicit reference to the Messiah here, still the confession is nonetheless remarkable. How many are there in our day who want to seem like the very best Christians, yet nevertheless speak so clumsily about divine matters and live so shamefully that they seem to believe in God’s existence with almost no resolve? Or if they do believe that he exists, nevertheless they do not believe that he governs all things but instead perceive God exercises more effective concern for the wicked, seeing how they are filled with all good possessions. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILY 9 ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 2:8-11")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-187",
      "id": "ap_ntf-187-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_37",
      "title": "37"
    }
  }, [_c('b', [_vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OW")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ID")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AHAB")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OME TO")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AVE")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HIS")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AITH?")])]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AYER:")]), _vm._v(" If it be demanded how Rahab attained to such certain and saving faith, when she had heard no more but a rumor of things done by the Lord for Israel, and saw with what fear the inhabitants of Jericho were struck, which were only natural means, which all had as well as she—I answer, God wrought grace supernaturally in her heart, by these means to know and believe in him, as he has done diverse times in whom he pleases. The terror of which she speaks came upon them, doubtless, not only by a natural awareness of the danger, in which they were, but also an awareness of judgment sent by God into their hearts, in order to make the subduing of them all the easier for the Israelites, according to the promise made in Exodus 23:27. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 2:9")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-188",
      "id": "ap_ntf-188-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AHAB’S")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AITH")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAMES THE")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SRAELITES AND")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEIR")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("FTEN")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EAK")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AITH")]), _vm._v(".")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RTHUR")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ACKSON:")]), _vm._v(" Indeed it can be observed that whereas the Israelites knew this [land] had been promised to their fathers for many generations, and had heard that promise often confirmed to them by Moses, and had seen great things that God had done for them, and yet notwithstanding all these things fell prey to fear, this poor woman, who had only heard of a report of the wonders which God had done for them, was confidently persuaded that God would give them the land, and made no question of it . . . so that while these spies were to all appearances in such a desperate danger, being locked up in a city of their enemies, and not knowing how to escape, she could beg of them that kindness and mercy to be shown to her and her family, no differently than if they had taken the city already, and all the lives of the inhabitants were at their disposal. A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNOTATIONS ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 2:9")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-189",
      "id": "ap_ntf-189-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EBREWS AND")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANAANITES")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("POKE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IMILAR")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANGUAGES")]), _vm._v(".")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RTHUR")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ACKSON:")]), _vm._v(" As for their talking thus together, being of two different nations, we need not wonder, for certainly the language of the Canaanites and other neighboring nations was not in those times much different from that of the Hebrew, as is very evident by the fact that many names both of people and cities among the Canaanites are quite similar. A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNOTATIONS ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 2:9")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-190",
      "id": "ap_ntf-190-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EWS OF")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAT")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AD")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LREADY")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONE")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENT IN")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DVANCE OF THE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONQUEST")]), _vm._v(".")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALVIN:")]), _vm._v(" It was impossible to doubt that the way through the Red Sea had been miraculously opened up. . . . The transmutation of the element, therefore, plainly showed that God was on the side of the people to whom he had given a dry passage through the depths of the sea. The remarkable victories also gained over Og and Bashan were justly regarded as testimonies of the divine favor towards the Israelites. . . . Everyone in Jericho, therefore, was seized with a conviction that in the action of the Israelites, God was principal leader; hence their terror and consternation. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 2:10")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-191",
      "id": "ap_ntf-191-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSPEL")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AS")]), _vm._v(" K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NOWN")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MONG")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENTILES FROM")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONG")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("GO")]), _vm._v(".")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UDWIG")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AVATER:")]), _vm._v(" From these comments we gather that God also had his own worshipers among the Gentiles before the coming of Christ. For this woman Rahab was a Canaanite, Ruth was a Moabitess, and Job an Idumean, Jethro a Midianite. I do not mention others whom we must believe were saved, not through pagan religion, of course, but through true faith in Christ. For these nations possessed many things passed down from the traditions of their fathers. Also, when the Jews were scattered here and there because of their different wars, they taught the Gentiles the true religion. Many of the nations also came to Jerusalem because of the renown of the city, and there they heard sermons about the Messiah. In addition, they had their own Sybils who predicted a great deal about the circumstances "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_38",
      "title": "38"
    }
  }, [_vm._v("of Christ. God sometimes also sent prophets to the nations, for he sent Jonah to Nineveh and other prophets to other nations to summon them to true repentance. Along these lines we read in Ephesians 2, “The Gentiles were estranged from Christ and from the hope of salvation.” This does not prevent God from having laid hold of some of them. But if we must speak about public profession of faith, then the situation of the Gentiles, especially at that time, was very bad. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILY 9 ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 2:8-11")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-192",
      "id": "ap_ntf-192-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AD")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LREADY")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORKED IN")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ER")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EART")]), _vm._v(".")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARDINAL")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AJETAN:")]), _vm._v(" See in that woman not only fear but also faith and an obvious confession that Jehovah, who is Israel’s God, is himself God in heaven and earth. Furthermore, it is not astonishing that she was saved, for her whom God illuminated inwardly and made a Savior of his own elect he also saved from the slaughter of Jericho. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 2:11")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-193",
      "id": "ap_ntf-193-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("A R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EMARKABLE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONFESSION OF")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AITH")]), _vm._v(".")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARTIN")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORRHAUS:")]), _vm._v(" A remarkable confession of faith in God is given here by the Gentile woman Rahab. Therefore, what is said by the apostle is true: “God shows no partiality, but in every nation any who fears him is acceptable to him.” In removing the veil in the Amorite, a true Israelite is found, by faith an offspring of Abraham. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 2:11")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-194",
      "id": "ap_ntf-194-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OT")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LL OF")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERICHO")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EFIED")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD")]), _vm._v(".")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENEVA")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IBLE:")]), _vm._v(" Herein appears the great mercy of God, that in this common destruction he would cause a most miserable sinner to repent and confess his name. A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNOTATIONS ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 2:11")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-195",
      "id": "ap_ntf-195-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AHAB’S")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONFESSION OF")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELIEF IN")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORTHY TO")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("E")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLED")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AITH")]), _vm._v(".")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALVIN:")]), _vm._v(" Here the image of Rahab’s faith appears as if reflected in a mirror when, casting down all idols, she ascribes the government of heaven and earth to the God of Israel alone. For it is perfectly clear that when heaven and earth are declared subject to the God of Israel, there is a repudiation of all the pagan fictions by which the majesty, and power, and glory of God are portioned out among different deities; and hence we see that it is not without cause that two apostles have honored Rahab’s conduct with the title of faith. . . . I deny not that her faith was not fully developed, nay, I readily admit that it was only a seed of piety that, as yet, would have been insufficient for her eternal salvation. We must hold, nevertheless, that however feeble and slender the knowledge of God that the woman possessed may have been, still in surrendering herself to his power, she gives a proof of her election, and that from that seed a faith was germinating which afterward attained its full growth. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 2:11")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-196",
      "id": "ap_ntf-196-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-027"
    }
  }, [_c('h3', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('b', [_vm._v("2:12-14 "), _c('i', [_vm._v("The Promise Rahab Secures to Spare Herself and Her Family")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERCY, BUT")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LSO")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RACE")]), _vm._v(".")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARDINAL")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AJETAN:")]), _vm._v(" On both sides one ought to read “grace,” for that word which is commonly translated “mercy” nonetheless according to Hebrew truth means “grace,” when it is examined more carefully, because it is not the name for an affection of the mind, but rather for the bestowal of something undeserved—which in Latin we call “grace.” C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 2:12")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-197",
      "id": "ap_ntf-197-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AHAB’S")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CT OF")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AITH")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AS")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NDEED")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EMARKABLE")]), _vm._v(".")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NGLISH")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNOTATIONS:")]), _vm._v(" Here Rahab shows and exercises a singular act of faith. For whereas the people of Israel, despite all of God’s promises confirmed to them by many miracles, were always ready to stumble and doubt of their fulfillment she, on the basis of hearsay "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_39",
      "title": "39"
    }
  }, [_vm._v("reports alone, was so confidently persuaded of the truth of them that she desires to enter into covenant with the spies for her own life and that of her friends, as if they had already stormed the city, and had the power of life and death in their hands; and that even when the spies themselves had great cause of fear in respect of their present condition, being surrounded with enemies, and shut up in the city, not seeing with the eye of reason any probable means of making an escape. In this she consulted not with natural reason, which would have told her that her guests were at this moment in a desperate condition and not able to save her or themselves, but rather with the eye of faith looking to God’s power and the truth of his promises, she completely relies upon them in the absence of all earthly means, and requests the spies to ratify by oath a covenant with her for the life and safety of her and all her friends. A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNOTATIONS ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 2:12")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-198",
      "id": "ap_ntf-198-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AHAB")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HOWS A")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AITH IN")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HINGS AS")]), _vm._v(" Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ET")]), _vm._v(" U"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NSEEN")]), _vm._v(".")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALVIN:")]), _vm._v(" In the language of Rahab, we witness that characteristic property of faith described by the author of the epistle to the Hebrews, when he calls it a vision or sight of things not appearing. Rahab is dwelling with her people in a fortified city, and yet she commits her life to her terrified guests, just as if they had already gained possession of the land, and had full power to save or destroy as they pleased. This voluntary surrender was, in fact, the same thing as embracing the promise of God, and casting herself on his protection. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 2:12")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-199",
      "id": "ap_ntf-199-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AHAB")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EVISED THE")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EANS OF")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SCAPE")]), _vm._v(".")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RTHUR")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ACKSON:")]), _vm._v(" The kindness that Rahab here says she had shown to the spies was not only hiding them from the king’s messengers but also the plan she had devised and resolved on for the letting of them down out of her window (and indeed the former action would have been but a small kindness to them without the latter), and therefore without questions she had acquainted them with her resolution in this, though that is not here expressed. A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNOTATIONS ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 2:12")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-200",
      "id": "ap_ntf-200-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SKS FOR")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERTAINTY BY")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EANS OF A")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGN")]), _vm._v(".")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARDINAL")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AJETAN:")]), _vm._v(" It differs a little from the Hebrew, which reads, “And you will give me a sign of truth.” The woman calls the oath “a sign of truth.” If she had said it more plainly, she would have said, “Swear to me by Jehovah in such a way that it will be a sign of the future truth.” And she said this to prevent sophistry about the oaths, given that they were made in fear and out of need. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 2:12")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-201",
      "id": "ap_ntf-201-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AHAB")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARGAINS FOR")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AFETY")]), _vm._v(".")]), _vm._v(" K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONRAD")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELLIKAN:")]), _vm._v(" She now pleaded her cause and brought about her rescue just in time. She employed well her recent act of kindness and took heed for the safety of many people by her plan, which she revealed to the men where they were resting, desperate in their anxiety. She required the spies to swear that her household would be safe, which (with thanks to God) the faithful matron was able to achieve—not by her own gods, but by the Lord God of Israel. She did not reproach them with the kindness she had shown them, yet she maintained that it be repaid to her by the men. . . . Nor did she want to save only herself without her parents and other household members. Also, she wisely demanded a sign in order that she might be kept safe . . . and not killed. . . . Finally, she wanted a true sign and not a false and uncertain one. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 2:12-13")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-202",
      "id": "ap_ntf-202-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("Y")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAT")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARRANT")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ID THE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PIES")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROMISE")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ER")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALVATION?")])]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UDWIG")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AVATER:")]), _vm._v(" Now we can discuss the topic of how these two spies dared to promise a rescue for Rahab and those with her, when God had ordered that all the Canaanites and "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_40",
      "title": "40"
    }
  }, [_vm._v("those condemned people be handed over to destruction (as he had later ordered Saul to slay the Amalekites). This question is especially pertinent since in a commonwealth spies do not possess full authority. We answer that they most certainly thought that the law of God was not so strict that it would not allow an appropriate interpretation and exception. In addition, they trusted that Joshua and the other leaders of war would have proper regard for what they had promised for so compelling a reason. It can also be stipulated that Joshua had ordered them to promise life to anyone who would take them in. Thus in Judges 1 the spies promise life to those who had pointed out to them the entrance to the city. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILY 10 ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 2:12-15")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-203",
      "id": "ap_ntf-203-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("XCHANGE OF")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATHS")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IKE A")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REATY")]), _vm._v(".")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARDINAL")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AJETAN:")]), _vm._v(" It reads in the Hebrew as “If you will not betray this word of ours.” They swear in the manner of a treaty and, because they did not yet know that they would be sent through the window, they are cautious lest the knowledge that they are hiding there be communicated to the father and mother, brothers and sisters of the woman and so become public knowledge. Therefore, they affix to this agreement the provision, “If you will not betray this matter of ours.”")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("“Whenever the Lord will hand over the land to us, we will show you mercy.” It ought to be read, “We will show you grace and truth.” For the previously spoken wording is repeated. And they call “grace” the kindness of life, but “truth” they call faithfulness in keeping the promises. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 2:14")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-204",
      "id": "ap_ntf-204-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATH OF THE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PIES")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AS TO")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IND")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEMSELVES")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EFORE")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD")]), _vm._v(".")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALVIN:")]), _vm._v(" They call for death upon themselves if they do not faithfully make it their business to save Rahab. For the interpretation adopted by some, “we will pledge our lives,” seems far-fetched, or too restricted, since their intention was simply to bind themselves before God. They constitute themselves, therefore, each a kind of expiatory victim, if any evil befalls Rahab through their negligence. . . . And herein consists the sanctity of an oath, that though one may escape its violation without consequences so far as humans are concerned yet God, having been called as a witness, will take account of the betrayal. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 2:14")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-205",
      "id": "ap_ntf-205-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CARLET")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HREAD OF")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALVATION")]), _vm._v(".")]), _vm._v(" K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONRAD")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELLIKAN:")]), _vm._v(" They promised in the name of all Israel that she would be kept safe, since she was a faithful host and devoted to God—if and only if she continued to be faithful and kept quietly within her house along with her family and did not neglect the sign of the red thread. Just so, within the unity of the church, the faithful are saved by the blood of Christ. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 2:14")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-206",
      "id": "ap_ntf-206-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARNING TO")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AHAB")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EFERS TO THE")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("GREEMENT")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETWEEN")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ER AND THE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PIES")]), _vm._v(".")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RTHUR")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ACKSON:")]), _vm._v(" Some expositors say that in order to bind her more strictly to persevere in this which she had begun to do, and not to betray them as soon as they were gone, they annex this condition, and thereby give her a warning: that if she brought them in danger by exposing them, though God should preserve them by some other means, yet she must expect no mercy from them. But I rather perceive that the business they speak of here is chiefly the covenant agreed on between them concerning the preservation of her and her family, and the sign whereby they were to identify her house, as seems probable, where the spies, having spoken of this agreement between them, then repeat the words. . . . The meaning of the words is that if by making known the agreement they had made, others besides her kindred should crowd into her house, or by using the same token of "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_41",
      "title": "41"
    }
  }, [_vm._v("hanging out a scarlet thread, others might think to preserve their households as well from the public destruction, the spies would not then be bound by their oath to afford her or her family any mercy. A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNOTATIONS ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 2:14")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-207",
      "id": "ap_ntf-207-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARNING")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AS FOR")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AHAB’S")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("WN")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROTECTION")]), _vm._v(".")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALVIN:")]), _vm._v(" This was inserted, not on account of distrust of Rahab, as it is usually understood, but only to put Rahab the more on her guard on her own account. The warning, therefore, was given in good faith, and flowed from a pure goodwill; for there was a danger that Rahab might betray herself by a disclosure. In one word, they show how important it is that the matter should remain, as it were, buried, lest the woman, by carelessly talking of the agreement, might expose herself to capital punishment. In this they show that they were sincerely anxious for her safety, since they thus early on warn her against doing anything that might put it out of their power to serve her. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 2:14")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-208",
      "id": "ap_ntf-208-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PIES")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEDGE")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEIR")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IVES TO")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONOR")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEIR")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROMISE")]), _vm._v(".")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NGLISH")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNOTATIONS:")]), _vm._v(" We guarantee you on the penalty of our own lives, which we desire God take from us if we are not true and faithful to you in our promise. Or, we will preserve your life and that of your kindred, even with the hazard or loss of our own . . . provided you do not reveal our oath to you, or the sign we give you for your assurance and safety, either to any of your fellow citizens, or more specially to others for whom this preservation is not intended, to keep themselves out of danger, either by forcing themselves into your house, or by making use of the same sign we give to you. And only upon the observing of this covenant we will be bound to preserve you and your kindred. A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNOTATIONS ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA 2:14")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen17#ntf-209",
      "id": "ap_ntf-209-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_42",
      "title": "42"
    }
  })])])]), _c('section', {
    staticClass: "defnotes",
    attrs: {
      "epub:type": "footnotes"
    }
  }, [_c('aside', {
    staticClass: "ntb",
    attrs: {
      "epub:type": "footnote",
      "id": "ntb-003"
    }
  }, [_c('p', {
    staticClass: "txt_ssalinea"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap5#ap_ntb-003-1"
    }
  }, [_vm._v("a")]), _vm._v(". Hebrew "), _c('i', [_vm._v("they")])])]), _c('aside', {
    staticClass: "ntb",
    attrs: {
      "epub:type": "footnote",
      "id": "ntb-004"
    }
  }, [_c('p', {
    staticClass: "txt_ssalinea"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap5#ap_ntb-004-1"
    }
  }, [_vm._v("b")]), _vm._v(". That is, set apart (devoted) as an offering to the Lord (for destruction)")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09559184","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/p1chap5.vue
// module id = 96
// module chunks = 0